module.exports = __webpack_public_path__ + "img/simple_loader.897e0989.webp";